import { EnumOption } from "./enum-option"

export const PWPeriod = {
    Hour: 0,
    Week: 1,
    BiWeekly: 2,
    Month: 3,
    Year: 4,
}

export const PWPeriodList: EnumOption[] = [
    { value: PWPeriod.Hour, label: 'Hour' },
    { value: PWPeriod.Week, label: 'Week' },
    { value: PWPeriod.BiWeekly, label: 'Bi-weekly' },
    { value: PWPeriod.Month, label: 'Month' },
    { value: PWPeriod.Year, label: 'Year' },
]
